import { render, staticRenderFns } from "./ViewHandOver.vue?vue&type=template&id=128b3f3e&scoped=true"
import script from "./ViewHandOver.vue?vue&type=script&lang=js"
export * from "./ViewHandOver.vue?vue&type=script&lang=js"
import style0 from "./ViewHandOver.vue?vue&type=style&index=0&id=128b3f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128b3f3e",
  null
  
)

export default component.exports